import { useCallback } from "react";

import useDeleteApplication from "../../../../clients/applications/useDeleteApplication";
import useUpsertApplication from "../../../../clients/applications/useUpsertApplication";
import Application from "../../domain/Application";

export default function useApplicationWriter(application: Application, onSave: (application: Application) => void) {
    const [record] = useUpsertApplication(application);
    const [remove] = useDeleteApplication(application.domain);

    const edit = useCallback(
        async function save() {
            const result = await record({ errorPolicy: "all" });

            if (result.error) {
                const error = result.error as { errors?: { message?: string }[], graphQLErrors?: { message?: string }[] };
                const graphQLErrors = error?.errors ?? error?.graphQLErrors;
                const message = graphQLErrors?.[0]?.message
                    ?? result.error.message
                    ?? "Failed to save application.";

                if (message.includes("E11000") && message.includes("domain")) {
                    throw new Error("Domain already in use — another application already uses this domain.");
                }
                throw new Error(message);
            }

            if (!result.data?.upsertApplication) {
                throw new Error("Failed to save application.");
            }

            onSave?.(
                application.change({ domain: result.data.upsertApplication.domain })
            );
        },
        [record, application, onSave],
    );

    return [edit, remove];
}
